import { spacing, VNode, VNodeData } from '@/js/lib/helper-classes'
import uuid from 'uuid/v4'
import _ from 'lodash'

export class CContainer {
  tag = 'c-container'
  data = new VNodeData({
    props: {
      borderPosition: {
        all: 'set',
        lft: '',
        ryt: '',
        btm: '',
        top: '',
      },
      class: {},
      style: {},
      vnodeId: uuid(),
      domProps: {},
      attrs: {},
      ...spacing({
        margin: {
          vertical: 'my-0',
          horizontal: 'mx-0',
        },
        padding: {
          vertical: 'py-1',
          horizontal: 'px-1',
        },
      }),
      background: {
        image: '',
        size: 'cover',
        repeat: 'no-repeat',
        y: 0,
        active: 'image',
      },
      border: '',
      borderRadius: 0,
      shadow: '',
      desktop: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'start',
        alignItems: 'start',
        alignContent: 'start',
        horizontalGap: 0,
        verticalGap: 10,
      },
      phone: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'start',
        alignItems: 'start',
        alignContent: 'start',
        horizontalGap: 0,
        verticalGap: 10,
      },
    },
  })
  children = []

  constructor() {
    let _spacing = spacing({
      margin: {
        vertical: 'my-0',
        horizontal: 'mx-0',
      },
      padding: {
        vertical: 'py-1',
        horizontal: 'px-1',
      },
    })
    this.data.props.margin = _spacing.margin
    this.data.props.padding = _spacing.padding
  }
}

export class CContainerItem extends VNode {
  tag = 'c-container-item'
  children = []
  data = new VNodeData({
    props: {
      borderWidth: 0,
      borderStyle: "",
      borderColor: "",
      borderRadius: 0,
      desktop: {
        width: 'default',
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'auto',
        flexBasis: 'auto',
        sizeType: 'none',
        height: 'auto',
      },
      phone: {
        width: '100%',
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'auto',
        flexBasis: 'auto',
        sizeType: 'none',
        height: 'auto',
      }
    },
  })
  constructor(opts) {
    super(opts)
    const { desktop, phone } = opts
    this.data.props.desktop.width = desktop?.width || 'default'
    this.data.props.desktop.flexGrow = desktop?.flexGrow || 0
    this.data.props.desktop.flexShrink = desktop?.flexShrink || 0
    this.data.props.desktop.alignSelf = desktop?.alignSelf || 'auto'
    this.data.props.desktop.flexBasis = desktop?.flexBasis || 'auto'
    this.data.props.desktop.sizeType = desktop?.sizeType || 'none'
    this.data.props.phone.width = phone?.width || '100%'
    this.data.props.phone.flexGrow = phone?.flexGrow || 0
    this.data.props.phone.flexShrink = phone?.flexShrink || 0
    this.data.props.phone.alignSelf = phone?.alignSelf || 'auto'
    this.data.props.phone.flexBasis = phone?.flexBasis || 'auto'
    this.data.props.phone.sizeType = phone?.sizeType || 'none'
  }
}